import { Collapse } from "antd";
import React, { useState } from "react";

import { BevoegdheidModal } from "./components/BevoegdheidModal.jsx";
import { Category } from "./components/Category.jsx";

import "./bevoegdheden.css";
import { $t } from "~/i18n.js";
import { ParseMessage } from "../atom/parseMessage.jsx";

export const BevoegdhedenClusterTab = ({
  pilot,
  setBevoegdheid,
  behaalde_bevoegdheden,
  cluster,
}) => {

  
  const [bevoegdheid, openBevoegdheid] = useState(null);

  // Determine which tabs must be default open, and also get a count of achieved bevoegheden
  let defaultActiveKeys = [];
  let latestAchievement = null;

  // For DTO clusters, find the latest achievement
  if (cluster.is_dto) {
    let latestDate = null;
    
    for (let i = 0; i < cluster.category.length; i++) {
      cluster.category[i].bevoegdheid.forEach((bev) => {
        const achievement = behaalde_bevoegdheden[bev.id];
        if (achievement && achievement.date_assigned) {
          const achievementDate = new Date(achievement.date_assigned);
          if (!latestDate || achievementDate > latestDate) {
            latestDate = achievementDate;
            latestAchievement = {
              category: cluster.category[i],
              bevoegdheid: bev,
              achievement: achievement,
              date: achievement.date_assigned
            };
          }
        }
      });
    }
  }

  for (let i = 0; i < cluster.category.length; i++) {
    cluster.category[i].count = 0;
    cluster.category[i].nearly_invalid = false;
    cluster.category[i].bevoegdheid.forEach((bevoegdheid) => {
      bevoegdheid.behaald = behaalde_bevoegdheden[bevoegdheid.id] || {};
      
      // Flag the latest achieved bevoegdheid for DTO clusters
      if (cluster.is_dto && latestAchievement && 
          bevoegdheid.id === latestAchievement.bevoegdheid.id) {
        bevoegdheid.isLatestAchieved = true;
      }
      
      if (bevoegdheid.behaald.assigned) cluster.category[i].count += 1;
      if (bevoegdheid.behaald.nearly_invalid)
        cluster.category[i].nearly_invalid = true;
    });

    // add to default open if items are open and none is already opened
    if (
      defaultActiveKeys.length < 1 &&
      cluster.category[i].count < cluster.category[i].bevoegdheid.length
    ) {
      defaultActiveKeys = [i];
    }
  }

  return (
    <div style={{ maxWidth: 500 }}>
      <BevoegdheidModal
        bevoegdheid={bevoegdheid}
        user_id={pilot.id}
        closeModal={() => openBevoegdheid(null)}
        setBevoegdheid={setBevoegdheid}
        cluster={cluster}
      />

      {(cluster.description || cluster.curriculum_versie) && (
        <Collapse
          bordered={false}
          ghost
          size="small"
          items={[
            {
              key: "description",
              label: $t("Beschrijving"),
              children: (
                <section style={{ marginBottom: "16px" }}>
                  <ParseMessage className='userInput' message={cluster.description}/>
                  {cluster.curriculum_versie && (
                    <p>
                      <span className="label">{$t("Versie")}</span>{" "}
                      <span>{cluster.curriculum_versie}</span>
                    </p>
                  )}
                </section>
              ),
            },
          ]}
        />
      )}

      <Collapse
        bordered={false}
        className="BevoegdheidCollapsible"
        defaultActiveKey={defaultActiveKeys}
      >
        {cluster &&
          cluster.category?.map((category, key) =>
            Category(
              key,
              category,
              pilot.id,
              cluster,
              setBevoegdheid,
              openBevoegdheid,
              latestAchievement
            )
          )}
      </Collapse>
    </div>
  );
};
